import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { Home, FileText, Shield, Settings } from 'lucide-react';
import { motion } from 'framer-motion';

const navItems = [
  { path: '/devices', icon: Home, label: 'Дом' },
  { path: '/scripts', icon: FileText, label: 'Сценарии' },
  { path: '/safety', icon: Shield, label: 'Охрана' },
  { path: '/settings', icon: Settings, label: 'Ещё' },
];

export const BottomNavigation: React.FC = () => {
  const location = useLocation();
  
  const hiddenRoutes = [
    '/devices/',
    '/scripts/new',
    '/scripts/edit',
    '/safety/settings',
    '/statistics/',
    '/pairing'
  ];
  
  if (hiddenRoutes.some(route => 
    location.pathname.includes(route) && 
    location.pathname !== route.replace('/', '')
  )) {
    return null;
  }

  return (
    <motion.nav 
      initial={{ y: 100 }}
      animate={{ y: 0 }}
      className="fixed bottom-0 left-0 right-0 z-50 px-4 pb-4"
    >
      <div className="glass max-w-md mx-auto rounded-2xl p-2">
        <div className="flex justify-around items-center">
          {navItems.map((item) => {
            const isActive = location.pathname.startsWith(item.path);
            const Icon = item.icon;
            
            return (
              <NavLink
                key={item.path}
                to={item.path}
                className="relative flex flex-col items-center justify-center py-2 px-4"
              >
                {isActive && (
                  <motion.div
                    layoutId="activeNav"
                    className="absolute inset-0 gradient-primary rounded-xl"
                    transition={{ type: 'spring', stiffness: 500, damping: 30 }}
                  />
                )}
                
                <div className="relative z-10 flex flex-col items-center">
                  <Icon 
                    className={`w-5 h-5 transition-colors ${
                      isActive ? 'text-white' : 'text-slate-400'
                    }`} 
                  />
                  <span 
                    className={`text-[10px] mt-1 font-medium transition-colors ${
                      isActive ? 'text-white/90' : 'text-slate-400'
                    }`}
                  >
                    {item.label}
                  </span>
                </div>
              </NavLink>
            );
          })}
        </div>
      </div>
    </motion.nav>
  );
};
